"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styled_1 = require("@emotion/styled");
const theme_1 = require("../theme");
exports.default = styled_1.default.div `
	color: ${theme_1.default.colours.text.dark};

	.login {
		--pad: ${theme_1.default.spacing.small};
		padding: ${theme_1.default.spacing.small};
	}

	.login__row {
		margin: 0 0 ${theme_1.default.spacing.default};
	}

	.login__label {
		display: block;
		margin: 0 0 ${theme_1.default.spacing.small};
		font-size: ${theme_1.default.typography.styles.c1.size};
		line-height: ${theme_1.default.typography.styles.c1.height};
		font-weight: bold;
	}

	.login__error {
		display: block;
		margin: ${theme_1.default.spacing.small} 0 0;
		color: ${theme_1.default.colours.error.default};
	}

	.login__button,
	.login__children {
		margin: 0;
	}

	.login__button:not(:last-child) {
		margin: 0 0 ${theme_1.default.spacing.small};
	}

	@media only screen and (min-width: 468px) {
		.login {
			--pad: ${theme_1.default.spacing.large};
		}
	}
`;
//# sourceMappingURL=login.styled.js.map